<style lang="scss" scoped>
.progress {
  display: flex;

  height: 2.08rem;

  padding: 0 0.28rem;

  background-color: #fff;

  .card {
    flex: 1;

    text-align: center;

    .indicator {
      display: flex;

      position: relative;

      width: 100%;
      height: 0.8rem;
      margin-top: 0.21rem;

      justify-content: center;
      align-items: center;

      i {
        display: inline-block;

        position: relative;

        z-index: 1;

        width: 12px;
        height: 12px;

        background: #dadada;
        border-radius: 100%;
      }

      .bar {
        position: absolute;
        top: 0;
        bottom: 0;
        left: 50%;

        width: 100%;
        height: 1px;
        margin: auto 0;

        background-color: #dadada;

        &::after {
          display: block;

          height: 100%;

          background: #0daf52;

          content: '';
        }

        &.zero {
          &::after {
            width: 0;
          }
        }
        &.half {
          &::after {
            width: 50%;
          }
        }
        &.full {
          &::after {
            width: 100%;
          }
        }
      }
    }

    .status {
      font-size: 0.28rem;
      line-height: 0.51rem;

      color: #9b9b9b;
    }

    .date {
      font-size: 0.23rem;
      line-height: 0.34rem;
      color: #9b9b9b;
    }
    &.active {
      .indicator {
        i {
          background-color: #0daf52;
        }
      }

      .status {
        color: #333;
      }

      &.curr {
        .indicator {
          i {
            width: 0.48rem;
            height: 0.48rem;

            background-image: url('~@/images/new_good_req/suc2.png');
            background-size: 100%;
          }
        }
      }
    }
  }
}
</style>

<template>
  <div class="progress">
    <div
      v-for="(step, index) in steps"
      :key="index"
      class="card"
      :class="{
        active: step.active,
        curr: step.curr
      }"
    >
      <div class="indicator">
        <i></i>
        <div
          v-if="index < steps.length - 1"
          class="bar"
          :class="{
            zero: !step.active,
            half: step.curr,
            full: step.active && steps[index + 1] && steps[index + 1].active
          }"
        ></div>
      </div>
      <div class="status">{{ step.describe }}</div>
      <div v-show="step.time" class="date">{{ step.time }}</div>
    </div>
  </div>
</template>

<script>
const STATUS_MAP = {
  HAS_SUBMIT: 2, // 已提报
  HAS_ACCEPT: 3, // 已采纳
  ONLINE: 6 // 已上线
}

export default {
  props: {
    steps: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      STATUS_MAP
    }
  }
}
</script>
